import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'Header of tax id information section',
    defaultMessage: 'Tax ID Information',
    id: 'J6V7Vr',
  },
  taxInformationTooltip: {
    description: 'Tax identifier tooltip information',
    defaultMessage:
      'While tax settings are optional, accounts without a valid tax ID may be subject to local taxes. Once entered, these tax settings cannot be changed.',
    id: '4hbS7S',
  },
  taxIdentifierCheckboxLabel: {
    id: 'hKfL1H',
    defaultMessage: 'Add Tax Settings (Optional)',
    description: 'Checkbox Label for the checkbox that opens the tax identifier input',
  },
});
